
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"64","height":"64"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('filter',{attrs:{"id":"a","width":"159.4%","height":"159.4%","x":"-29.7%","y":"-26.6%","filterUnits":"objectBoundingBox"}},[_c('feOffset',{attrs:{"dy":"2","in":"SourceAlpha","result":"shadowOffsetOuter1"}}),_c('feGaussianBlur',{attrs:{"in":"shadowOffsetOuter1","result":"shadowBlurOuter1","stdDeviation":"6"}}),_c('feColorMatrix',{attrs:{"in":"shadowBlurOuter1","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.125573645 0"}})]),_c('rect',{attrs:{"id":"b","width":"64","height":"64","x":"0","y":"0","rx":"20"}})]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('use',{attrs:{"fill":"#000","filter":"url(#a)","xlink:href":"#b"}}),_c('use',{attrs:{"fill":"#F90","xlink:href":"#b"}}),_c('path',{attrs:{"fill":"#FFF","fill-rule":"nonzero","d":"M44.06 37.458l-4.241-.484a3.324 3.324 0 00-2.74.952l-3.072 3.072a25.12 25.12 0 01-11.005-11.005l3.09-3.09a3.327 3.327 0 00.951-2.739l-.484-4.208A3.342 3.342 0 0023.235 17h-2.889c-1.887 0-3.457 1.57-3.34 3.457.885 14.262 12.292 25.652 26.537 26.537C45.43 47.11 47 45.54 47 43.654v-2.89c.017-1.686-1.253-3.106-2.94-3.306z"}})])])
          )
        }
      }
    